import { useContext } from "react";
import { Navigate } from "react-router";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "../Shared/LoadingContent";
import { UserType } from "../../Variables";

export type CandidateStateProps = {
    doPersonalDetailsCheck: boolean,
}

/// Makes sure that the if the user is a candidate they dont need to complete the privacy policy update or provide their personal details. Will redirect to relevant page. 
// If user is not a candidate or they dont need to update anything then the child content is rendered.
export const CandidateStateRoute = (props: React.PropsWithChildren<CandidateStateProps>) => {
    const app = useContext(AppContext);
    
    if (!app.loading && app.userLoggedIn && app.loggedInUser && app.loggedInUser.UserType == UserType.Candidate && app.loggedInUser.PrivacyPolicyUpdateRequired && !app.policyUpdateToDate) {
        // user needs to accept the privacy policy changes
        return <Navigate to="/PrivacyPolicy" />;
    } else if (!app.loading && props.doPersonalDetailsCheck && app.userLoggedIn && app.loggedInUser && app.loggedInUser.UserType == UserType.Candidate && !app.loggedInUser.PersonalDetailsFilledIn) {
        // user needs to provide details
        return <Navigate to="/PersonalDetails" />;
    }

    return (<>
        <LoadingContent loading={app.loading} classes="w-100 text-center">
            {props.children}
        </LoadingContent>
    </>);
}